module.exports = __webpack_public_path__ + "static/media/example-of-file-company-tax-card.71f83429.pdf";